module.exports = __webpack_public_path__ + "static/media/S1N2-5.0f1541f1.svg";